<template>
  <div class="area-content">
    <div ref="area" class="mainArea">
      <div class="patient-box">
        <div class="head-pic">
          <img src="../../assets/img/hslogo2.png" alt="" style="width:100%;height:100%;" />
        </div>
      </div>
      <div class="order-box">
        <el-form ref="ruleForm" label-width="80px" :model="ruleForm" :rules="rules" size="medium">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone" type="number" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
            <el-button type="primary" v-if="sendMsgDisabled" style="float: right;" size="mini" :disabled="disabledBtn"
              @click.stop="getPhoneCode">获取验证码</el-button>
            <el-button v-if="!sendMsgDisabled" type="info" style="float: right;" size="mini" disabled>{{ count + ' 秒后重新获取'
            }}</el-button>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="ruleForm.code" type="number" placeholder="请输入验证码"></el-input>
          </el-form-item>
        </el-form>
        <div class="comfirm-btn">
          <el-button type="primary" style="width: 70%;" size="medium" @click.stop="submitForm('ruleForm')">确 定</el-button>
        </div>
      </div>
    </div>
    <div class="bottom-tips"> @版权所有：上海中健佳益健康管理有限公司</div>
    <ul class="bg-bubbles">
      <li v-for="i in 10" :key="i"></li>
    </ul>
    <!-- <el-button style="position: fixed; right: 0; top: 0; z-index: 9" type="primary" @click="generateImage">生成图片</el-button> -->
  </div>
</template>

<script>
import request from '@/utils/request';
import wx from 'weixin-js-sdk';
export default {
  name: 'AuthorizeTest',
  data: function () {
    var validatePhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入手机号'));
      } else {
        if (!this.isCellPhone(value)) {
          callback(new Error('输入手机号格式错误'));
        } else {
          callback();
        }
      }
    };
    return {
      disabledBtn: true,
      sendMsgDisabled: true,
      count: '',
      timer: null,
      labelPosition: 'right',
      ruleForm: {
        phone: '',
        code: '',
        openId: ''
      },
      rules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],

      }
    };
  },
  watch: {
    'ruleForm.phone': {
      handler: function (newV, oldV) {
        const that = this
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(newV)) {
          that.disabledBtn = false
        } else {
          that.disabledBtn = true
        }
      },
    }
  },
  beforeCreate() {
    document.title = '关联授权';
  },
  created(){
     this.getCode(); 
  },
  methods: {
    closeDiaglogHs(){
      this.$confirm('恭喜你,绑定成功！', '成功提示', {
          confirmButtonText: '我已确定',
          cancelButtonText: '取消',
          customClass:"customClassHs",
          confirmButtonClass:"confirmButtonClassHs",
          showClose:false,
          showCancelButton:false,
          closeOnClickModal:false,
          type: 'success',
          center: true
        }).then(() => {
          setTimeout(() => {
              wx.closeWindow();//关闭当前页面
            }, 800)        
        })
    },
    getPhoneCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.sendMsgDisabled = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.sendMsgDisabled = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
      this.sendVerifyCode();//发送验证码
    },
    // 发送验证码
    sendVerifyCode() {
      const that = this;
      let params = {
        phone: that.ruleForm.phone,
      };
      request
        .post('/wechat/sendVerifyCode', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: '短信发送成功;',
              type: 'success'
            });
          } else {
            this.$notify({
              title: '错误提示',
              duration: 0,
              type: 'warning',
              message: res.errMsg,
            });
            // this.$message({
            //   message: '错误提示:' + res.errMsg,
            //   type: 'warning',
            //   duration: 0,
            //   showClose: true,
            // });
          }
        })
    },
    // 获取授权
    getCode() {
      const vm = this;
      const AddId = 'wxabf3045f090b1f8d'; //我们公众号id定死
      const local = 'https://whale.hwason.cn/#/authorizeHs'; //重新定向的地址  encodeURIComponent(local)
      // const AddId = 'wx1a1cf7c547b07420'; //我们公众号id定死 snsapi_base snsapi_userinfo
      // const local = 'http://mwehealth.hwason.cn/#/coronavirusOrderIndex'; //重新定向的地址
      const code = this.getUrlParam('code'); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId   
      if (code == null || code === '') {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          AddId +
          '&redirect_uri=' + 
          encodeURIComponent(local) +
          '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect';
      } else {
        // vm.axios.get('/common/acceptOpenid', { params: { code: code } }).then((res) => {
        //   localStorage.setItem('openidWx', res.data.openid);
        //   // vm.access_token = res.data.access_token;
        // });
         vm.getOpenid(code); //调用获取openid接口
      }
    },
    // 封装获取参数code的方法
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
    // 确定提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveOpenId();
        } else {
          return false;
        }
      });
    },
    saveOpenId() {
      const that = this;
      let params = {
        phone: that.ruleForm.phone,
        verifyCode: that.ruleForm.code,
        openId: that.ruleForm.openId
      };
      request
        .post('/wechat/saveOpenId', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {
            that.closeDiaglogHs();//关闭页面
            // that.$notify({
            //   title: '成功提示',
            //   duration: 2000,
            //   type: 'success',
            //   message: "恭喜邦定成功",
            // });
            // setTimeout(() => {
            //   wx.closeWindow();//关闭当前页面
            // }, 3000)
          } else {
            this.$notify({
              title: '错误提示',
              duration: 0,
              type: 'warning',
              message: res.errMsg,
            });          
          }
        })
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    // 获取openid
    getOpenid(code) {
      const that = this;
      let params = {
        jsCode: code,
        appId: "wxabf3045f090b1f8d"
      };
      request
        .post('/wechat/getWechatOpenId', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {
            that.ruleForm.openId = res.data
          } else {
            this.$notify({
              title: '错误提示',
              duration: 0,
              type: 'warning',
              message: res.errMsg,
            });
          }
        })
    },
    // 获取网址参数
    getParamsFromURL(url) {
      if ('undefined' == url) {
        return {};
      }
      let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
      let paraObj = {};
      for (let i = 0; i < paraString.length; i++) {
        let j = paraString[i];
        paraObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length);
      }
      return paraObj;
    },

  }
};
</script>

<style>
 .customClassHs{
  width: 60vw !important;
  /* font-size: 18px !important; */
 }
 .confirmButtonClassHs{
   width: 100px !important;
 }
</style>

<style lang="scss" scoped>
.area-content {
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
  box-sizing: border-box;
  position: relative;
  // background: linear-gradient(0deg, #36c6ff, #c2e5f8);
  background: #c2e5f8;

  .bottom-tips {
    width: 100%;
    font-size: 14px;
    color: #8e8b8b;
    position: absolute;
    bottom: 10px;
    left: 0;
    text-align: center;
    // transform: translateX(-50%);
    // border: 1px solid red;

  }

  //气泡样式开始
  .bg-bubbles {
    position: absolute;
    // 使气泡背景充满整个屏幕；
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    // 如果元素内容超出给定的宽度和高度，overflow 属性可以确定是否显示滚动条等行为；
    overflow: hidden;

    li {
      position: absolute;
      // bottom 的设置是为了营造出气泡从页面底部冒出的效果；
      bottom: -160px;
      // 默认的气泡大小；
      width: 40px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.15);
      list-style: none;
      // 使用自定义动画使气泡渐现、上升和翻滚；
      animation: square 15s infinite;
      transition-timing-function: linear;

      // 分别设置每个气泡不同的位置、大小、透明度和速度，以显得有层次感；
      // &:nth-child(1) {
      //   left: 5%;
      // }

      &:nth-child(2) {
        left: 20%;
        width: 90px;
        height: 90px;
        animation-delay: 2s;
        animation-duration: 7s;
      }

      &:nth-child(3) {
        left: 25%;
        animation-delay: 4s;
        // background-color: red;
      }

      &:nth-child(4) {
        left: 40%;
        width: 60px;
        height: 60px;
        animation-duration: 8s;
        background-color: rgba(255, 255, 255, 0.15);
      }

      &:nth-child(5) {
        left: 70%;
      }

      &:nth-child(6) {
        left: 80%;
        width: 120px;
        height: 120px;
        animation-delay: 3s;
      }

      // &:nth-child(7) {
      //   left: 12%;
      //   width: 160px;
      //   height: 160px;
      //   animation-delay: 2s;
      //   background-color: rgba(255, 255, 255, 0.15);
      // }

      &:nth-child(8) {
        left: 55%;
        width: 20px;
        height: 20px;
        animation-delay: 4s;
        animation-duration: 15s;
      }

      &:nth-child(9) {
        left: 25%;
        width: 10px;
        height: 10px;
        animation-delay: 2s;
        animation-duration: 12s;
        background-color: rgba(255, 255, 255, 0.3);
      }

      // &:nth-child(10) {
      //   left: 85%;
      //   width: 160px;
      //   height: 160px;
      //   animation-delay: 5s;
      // }
    }

    // 自定义 square 动画；
    @keyframes square {
      0% {
        opacity: 0.5;
        transform: translateY(0px) rotate(45deg);
      }

      25% {
        opacity: 0.75;
        transform: translateY(-400px) rotate(90deg);
      }

      50% {
        opacity: 1;
        transform: translateY(-600px) rotate(135deg);
      }

      100% {
        opacity: 0;
        transform: translateY(-1000px) rotate(180deg);
      }
    }
  }
}

.mainArea {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  // border: 1px solid red;
  box-sizing: border-box;
  // background-color: #f6f6f6;
  padding: 5px 10px;
  z-index: 100;
  box-sizing: border-box;

  .patient-box {
    width: 100%;
    height: 177px;
    border-radius: 6px;
    // background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;

    .head-pic {
      width: 85px;
      height: 85px;
      //  border: 1px solid red;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .order-box {
    width: 100%;
    height: auto;
    padding: 10px 10px;
    border-radius: 6px;
    // background-color: #fff;
    box-sizing: border-box;
    // border: 1px solid red;
    margin-top: 20px;
    z-index: 1000;

    .comfirm-btn {
      width: 100%;
      // border: 1px solid red;
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }

    .order-title {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .order-info {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: left;
      color: #333333;
      margin-bottom: 6px;
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>
